import { ABP } from '@abp/ng.core';
import { TemplateRef } from '@angular/core';

export namespace Layout {
	export interface ThemeSettings {
		// 需要保存到服务器的
		style: number;
		publicLayoutStyle: number;

		asideMenuColor: 'dark' | 'light';
		headerColor: 'dark' | 'light';
		headerMenuColor: 'dark' | 'light';
		brandColor: 'dark' | 'light';
		classes: LayoutClasses;
	}

	export interface LayoutClasses {
		header: string[];
		header_container: string[];
		header_mobile: string[];
		header_menu: string[];
		aside_menu: string[];
		subheader: string[];
		subheader_container: string[];
		content: string[];
		content_container: string[];
		footer_container: string[];
	}

	export enum MenuStatus {
		AlwaysOpened,
		OpenOnHover,
	}

	export enum MenuPlacement {
		Left,
		Top,
	}

	export type LogoColor = 'dark' | 'light';

	export interface NavigationElement {
		name: string;
		element: TemplateRef<any>;
		order?: number;
	}

	export interface State {
		isMenuExpanded: boolean;
		isNavbarExpanded: boolean;
		smallScreen: boolean;
		isSidebarCollapsed: boolean;
		isMenuPlacementTop: boolean;
		mouseOnSidebar: boolean;
		isMenuSwitched: boolean;
		style: number;
		styleElement: HTMLStyleElement;
		menuPlacement: MenuPlacement;
		boxedLayout: boolean;
		menuStatus: MenuStatus;
		themeSettings: ThemeSettings;
		selectedTab?: ABP.Tab;
	}

	export type StateKeys = keyof State;
}
